import initModal from './initializers/Modal.js'
import initUser from './initializers/User.js'
import initCrm27Registration from './initializers/Crm27Registration.js'

const initApplication = () => {
  initModal()
  initUser()
  initCrm27Registration()
}

export default initApplication
